<script lang="ts" setup>
  defineEmits<{ click: [] }>();

  useHead({
    link: [
      {
        rel: 'preload',
        as: 'image',
        href: '/_ipx/f_webp/images/lo-hp-new/hero-sm.webp',
        media: '(max-width: 767px)',
        fetchpriority: 'high',
      },
      {
        rel: 'preload',
        as: 'image',
        href: '/_ipx/f_webp/images/lo-hp-new/hero-md.webp',
        media: '(min-width: 768px) and (max-width: 1279px)',
        fetchpriority: 'high',
      },
    ],
  });

  const { activeBreakpoint } = useDeviceType();
  const isMobile = computed(() => ['xxs', 'xs', 'sm'].includes(activeBreakpoint.value));
  const isTablet = computed(() => ['md', 'lg', 'xl', '2xl'].includes(activeBreakpoint.value));
</script>

<template>
  <section
    :key="activeBreakpoint"
    class="contain-strict relative w-full aspect-[515/789] md:aspect-[96/33] desktop-1660:aspect-[1448/352] overflow-hidden rounded-xl font-barlow text-center text-white"
    @click="$emit('click')"
  >
    <!-- Mobile -->
    <LazyLoggedOutNewHeroSm v-if="isMobile" />

    <!-- Tablet and small desktop -->
    <template v-else-if="isTablet">
      <NuxtImg
        class="absolute inset-0 z-0 w-full"
        src="/images/lo-hp-new/hero-md.webp"
        format="webp"
        densities="x1 x2"
        alt="TABLET FACE FORMER HEAVYWEIGHT CHAMPION ANDY RUIZ JR. AND WIN BIG!"
        fetchpriority="high"
        preload
        width="100vw"
        height="100%"
      />
      <div
        class="max-w-[60%] lg:max-w-[60%] absolute inset-0 flex flex-col items-start justify-start pt-[clamp(2rem,4.25vw,2.625rem)] pb-[clamp(2rem,4.25vw,2.625rem)] pl-[clamp(2rem,4.25vw,2.625rem)] pr-0 lg:pt-[clamp(2.625rem,4.3vw,3.75rem)] lg:pb-[clamp(2.625rem,4.3vw,3.75rem)] lg:pl-[clamp(2.625rem,4.3vw,3.75rem)]"
      >
        <NuxtImg
          class="max-w-[14rem] lg:max-w-[18.75rem] mx-0 mb-auto"
          src="/images/lo-hp-new/hero-logo-desktop.webp"
          format="webp"
          densities="x1 x2"
          alt="MAXDUEL LOGOTYPE"
          fetchpriority="high"
          preload
        />

        <div class="mt-0 mx-0 mb-auto text-left text-white">
          <p
            class="text-2xl tracking-[0.76px] not-italic font-extrabold leading-none lg:text-[clamp(2rem,3.5vw,2.25rem)]"
          >
            PLAY ORIGINAL PvP GAMES
          </p>
          <p
            class="flex items-center gap-2 font-extrabold leading-none text-[1.625rem] tracking-[0.86px] lg:text-[clamp(2.25rem,3.75vw,2.625rem)]"
          >
            TO
            <b
              class="italic text-[2.125rem] tracking-[1.22px] font-black text-[#5bb5fa] lg:text-[clamp(2.75rem,4.3vw,3.5rem)]"
            >
              WIN REAL CASH
            </b>
          </p>
        </div>

        <CoreButton
          color="green"
          class="min-w-52 h-[2.625rem] px-8 py-4 justify-center items-center mx-0 lg:h-[3.25rem] lg:text-lg lg:w-[14.25rem]"
        >
          <span class="font-inter text-base font-extrabold leading-none tracking-[0.16px] uppercase">PLAY NOW</span>
        </CoreButton>
      </div>
    </template>

    <!-- Wide desktop -->
    <LazyLoggedOutNewHeroLg v-else />
  </section>
</template>
